import React, { useEffect, useState } from "react";

import { Helmet } from 'react-helmet-async';
import sanitizeHtml from 'sanitize-html';
import { useOutletContext ,useLocation,Link,useNavigate} from "react-router-dom";
import CtntCategoryMenu from "Components/CtntCategoryMenu";
import GamePageBanner from "Components/GamePageBanner";
import GameSvcMainPageInfoInqApi from "Apis/GameSvcMainPageInfoInqApi";
import { useSelector } from 'react-redux';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import GameSvcMnyDpstPrdtCtntApi from "Apis/GameSvcMnyDpstPrdtCtntApi";
import "Assets/css/Shop.css";
import ImgWithFallback from "Utils/ImgWithFallback";
import MgpStore from "Stores/Store";
import ApiResultModal from "Components/ApiResultModal";

interface prdtCtntReps {
    gameSvcCd:string,
    prdtKindCd:string,
    prdtNm:string,
    prdtDesc:string,
    prdtUntPrc:string,
    pchsCrncyCd:string,
    pchsCrncySign:string,
    paidMny:string,
    freeMny:string,
    gameMnyNm:string,
    imgUrl:string,
    pchsLmtCnt:number,
    trxAllwYn:string,
    subsIntvNm:null,
    aplyStrtDtime:string,
    aplyStopDtime:string,
    allTimeYn:string,
    lmtYn?: string,
    soutYn?: string
}
const ShopCtntUi =() => {
    const navigate = useNavigate();
    const location= useLocation();
    
    // 전역 store에서 로그인 정보 실시간 구독
    const loginInfoRaw = useSelector((state: any) => state.LoginInfoState?.LoginInfo);
    const loginInfo = loginInfoRaw?.apiBody;
    const storeLang = useSelector((state: any) => state.LangSetState?.Lang);
    
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let getShopKindCd = query.get("shopKindCd");
    let getPrdtCd = query.get("prdtCd");
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const outletContext: any = useOutletContext<any>() || {};
    const outletGameMain = outletContext?.gameMainPageData;
    const outletLangData = outletContext?.langData;
    const [localGameMainData, setLocalGameMainData] = useState<any>(outletGameMain || null);
    const gameMainPageData = localGameMainData; // use local copy (may be fetched)
    const finalLangData = outletLangData || langData;
    // debug: log what we receive from parent outlet and important params
    useEffect(() => {
        console.log('[ShopCtntUi] outletContext:', outletContext);
        console.log('[ShopCtntUi] outletGameMain:', outletGameMain);
        console.log('[ShopCtntUi] localGameMainData:', localGameMainData);
        console.log('[ShopCtntUi] finalLangData:', finalLangData);
        console.log('[ShopCtntUi] query params:', { getGameSvcCd, getShopKindCd, getPrdtCd });
    }, [outletContext, outletGameMain, localGameMainData, finalLangData, getGameSvcCd, getShopKindCd, getPrdtCd]);

    // keep localGameMainData in sync when parent provides gameMainPageData later
    useEffect(() => {
        if (outletGameMain) {
            setLocalGameMainData(outletGameMain);
        }
    }, [outletGameMain]);

    const [ShopKindCdState,setshopKindCdState] = useState<string | null>(query.get("shopKindCd"));
    const [prdtLstState,setPrdtLstState] = useState<any[]>([]);

    const [imgUrlState,setImgUrlState] = useState<string | undefined>(undefined);
    const [prdtNmState,setPrdtNmState] = useState<string | undefined>(undefined);
    const [prdtDescState,setPrdtDescState] = useState<string | undefined>(undefined);
    const [pchsLmtCntState,setPchsLmtCntState] = useState<number>(0);
    const [prdtUntPrcState,setPrdtUntPrcState] = useState<number>(0);
    const [paidMnyState,setPaidMnyState] = useState<number>(0);
    const [freeMnyState,setFreeMnyState] = useState<number>(0);
    const [totMnyState,setTotMnyState] = useState<number>(0);
    const [pchsCrncySignState,setPchsCrncySignState] = useState<string | undefined>(undefined);
    const [allTimeYnState,setAllTimeYnState] = useState<string | undefined>(undefined);
    const [lmtYnState, setLmtYnState] = useState<string>("N");
    const [soutYnState, setSOutYnState] = useState<string>("N");
    const [aplyStrtDtimeState,setAplyStrtDtime] = useState<string | undefined>(undefined);
    const [aplyStopDtimeState,setAplyStopDtime] = useState<string | undefined>(undefined);

    const [prdtCtntRepsState,setPrdtCtntRepsState] = useState<prdtCtntReps | null>(null);
    const [countState,setCountState] = useState(1);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);
    const isPageReady = Boolean(finalLangData && prdtCtntRepsState && imgUrlState && prdtNmState && !isLoading);
    const isLoginInfoResolved = loginInfoRaw !== null;

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };
    const LstChngFunc = (ShopKindCdState:string) => {
        setshopKindCdState(ShopKindCdState);
    }
    let test1:any;

    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (640/2));
    const GameMnyPopFunc = (e:any)=>{
        if (!isPageReady) {
            openResultModal(finalLangData?.COMM_MAIN_LOADING_00 || "로딩중입니다. 잠시 후 다시 시도해주세요.");
            return;
        }

        // 컴포넌트 레벨에서 구독한 로그인 정보 사용
        if (!loginInfo || !loginInfo.login) {
            const currentUrl = encodeURIComponent(location.pathname + location.search);
            openResultModal(
                langData?.COMM_ALERT_LOGIN_REQUIRED_00 || "로그인이 필요한 서비스입니다.",
                () => navigate(`/Login?referrer=${currentUrl}`)
            );
            return;
        }
        
        // 로그인된 경우 팝업 열기
        const popup = window.open(e,"_blank","width=500,height=700 left="+popupX+"top="+popupY);
        if (!popup) {
            openResultModal(langData?.COMM_POPUP_BLOCKED_00 || "팝업이 차단되었습니다. 브라우저 팝업 허용 후 다시 시도해주세요.");
        }
    }

    const CntStateChngFunc = (ArithmeticOperators:string) => {
        if (soutYnState === "Y") {
            return;
        }
        switch(ArithmeticOperators){
            case "+":
                if(pchsLmtCntState != 0) {
                    if(countState < pchsLmtCntState){
                        setCountState(countState+1);
                    }
                    else {
                        break;
                    }
                }else {
                    setCountState(countState+1);
                }
            break;
            case "-":
                if(countState <= 1){
                    break;
                }else {
                    setCountState(countState-1)
                }
            break;
        }
    }
    const GotoDpstLstFunc = () => {
        navigate(`/MyPage/GameSvcMnyDpstLst`);
    }

    // 팝업에서 opener.GotoDpstLstFunc() 호출 가능하도록 window에 등록
    useEffect(() => {
        (window as any).GotoDpstLstFunc = GotoDpstLstFunc;
        return () => {
            delete (window as any).GotoDpstLstFunc;
        };
    }, []);
    useEffect(()=>{
        if(!isLoginInfoResolved || !storeLang) {
            return;
        }
        if(ShopKindCdState){
            GameSvcMnyDpstPrdtCtntApi(getGameSvcCd,ShopKindCdState,getPrdtCd).then((resp)=> {
                switch(resp.apiHdr.code) {
                    case "PYMT0000":
                        setImgUrlState(resp.apiBody.imgUrl)
                        setPrdtNmState(resp.apiBody.prdtNm)
                        setPchsLmtCntState(Number(resp.apiBody.pchsLmtCnt) || 0)
                        setPrdtUntPrcState(Number(resp.apiBody.prdtUntPrc) || 0)
                        setPchsCrncySignState(resp.apiBody.pchsCrncySign)
                        setAllTimeYnState(resp.apiBody.allTimeYn);
                        setLmtYnState(resp.apiBody.lmtYn || "N");
                        setSOutYnState(resp.apiBody.soutYn || "N");
                        setAplyStrtDtime(resp.apiBody.aplyStrtDtime);
                        setAplyStopDtime(resp.apiBody.aplyStopDtime);
                        setPaidMnyState((Number(resp.apiBody.paidMny) || 0));
                        setFreeMnyState((Number(resp.apiBody.freeMny) || 0));
                        setTotMnyState((Number(resp.apiBody.paidMny) || 0) + (Number(resp.apiBody.freeMny) || 0));
                        setPrdtCtntRepsState(resp as prdtCtntReps);
                        const dirty = resp.apiBody.prdtDesc || '';
                        const sanitized = sanitizeHtml(dirty,{});
                        setPrdtDescState(sanitized);
                    break;
                    default:
                        openResultModal(`${resp.apiHdr.msg}`,() => {
                            GotoDpstLstFunc();
                        });
                }
            }).catch(()=>{
                // ignore for now
            })
        }
    },[ShopKindCdState, getGameSvcCd, getPrdtCd, isLoginInfoResolved, storeLang])

    // build menu data similarly to ShopLstUi so CtntCategoryMenu works
    const getCurrentParams = () => {
        const params = new URLSearchParams(location.search);
        const rawCtnt = params.get("ctntKindCd") || params.get("shopKindCd") || getShopKindCd;
        return {
            currentGameSvcCd: params.get("gameSvcCd") || getGameSvcCd,
            currentCtntCtgrCd: rawCtnt ? String(rawCtnt).toUpperCase() : null,
            currentPage: parseInt(params.get("page") || "1")
        };
    };
    const currentParams = getCurrentParams();

    const currentMainMenu = gameMainPageData?.menu?.find((menu: any) => {
        if (currentParams.currentCtntCtgrCd) {
            return menu.subMenuLst?.some((sub: any) => {
                const urlParams = new URLSearchParams(sub.url?.split('?')[1] || '');
                const rawSub = urlParams.get('ctntKindCd') || urlParams.get('shopKindCd') || getShopKindCd || sub.menuCd;
                const subCtntKindCd = rawSub ? String(rawSub).toUpperCase() : null;
                return subCtntKindCd === currentParams.currentCtntCtgrCd;
            });
        }
        const currentPath = location.pathname.toLowerCase();
        const menuCd = menu.menuCd?.toLowerCase() || '';
        return currentPath.includes(menuCd) || 
               menu.subMenuLst?.some((sub: any) => {
                   const subMenuCd = sub.menuCd?.toLowerCase() || '';
                   return currentPath.includes(subMenuCd);
               });
    });

    const ctntMenuData = currentMainMenu?.subMenuLst?.map((subMenu: any) => {
        const urlParams = new URLSearchParams(subMenu.url?.split('?')[1] || '');
        const rawCode = urlParams.get('ctntKindCd') || urlParams.get('shopKindCd') || subMenu.menuCd;
        const ctntKindCd = rawCode ? String(rawCode).toUpperCase() : '';
        return {
            Link: subMenu.url || '#',
            Txt: subMenu.menuNm,
            Display: subMenu.useYn,
            Code: ctntKindCd,
            BlankYn: subMenu.blankYn
        };
    }) || [];
    const visibleMenus = ctntMenuData.filter((menu: any) => menu.Display === "Y");

    // if neither parent provided data nor we've synced it, fetch once using API
    useEffect(() => {
        if (!localGameMainData && !outletGameMain && getGameSvcCd) {
            GameSvcMainPageInfoInqApi(getGameSvcCd).then((resp) => {
                if (resp) setLocalGameMainData(resp);
            }).catch(() => {
                // ignore
            });
        }
    }, [localGameMainData, outletGameMain, getGameSvcCd]);

    const handlePageChange = (_: any) => { /* noop for content page */ };
    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
        />
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.GAME_SVC_SHOP_PAGE_TITL_00}`}</title>
        </Helmet>
        <div className="BgW">
            <div className="gameBannerArea">
                    {localGameMainData ? (
                            <GamePageBanner gameMainPageData={gameMainPageData} langData={finalLangData} />
                    ) : (
                            <div className="gameBannerPlaceholder" style={{minHeight:160}} />
                    )}

            </div>
            <div className="shopContainer dFlex gap77 pt65 shopItemInfoContainer">
                <div className="itemImgWrap">
                    <div className={`itemImgFrame ${soutYnState === "Y" ? "disabled" : ""}`}>
                        <ImgWithFallback src={imgUrlState} alt="" />
                    </div>
                    {pchsLmtCntState != 0 ?
                        <div className="itemLmtCntWrap">
                            <p>{langData&&langData.GAME_SHOP_PRDT_CNT_LBL_00}</p>
                            {/* <p>남은 구매 횟수:</p> */}
                            <span className="colR">{pchsLmtCntState}</span>
                        </div>:
                        <></>
                    }
                </div>
                <div className="itemTxtWrap">
                    <h1 className="prdtNm">{prdtNmState}</h1>
                    <div className="itemTxtRow">
                        <ul>
                            <li className="prdtLbl">
                                <p>{langData&&langData.GAME_SHOP_MNY_PRC_LBL_00}</p>
                                {/* 판매가격 */}                                
                            </li>
                            <li  className="lblValue red">
                                <p><span>{pchsCrncySignState}</span>{(Number(prdtUntPrcState||0)).toLocaleString()}</p>
                            </li>
                        </ul>
                        <ul className="mt20">
                            <li className="prdtLbl">
                                <p>{langData&&langData.GAME_SHOP_MNY_CNT_LBL_00}</p>
                                {/* 수량 */}
                            </li>
                            <li className="cntWrap">
                                <button disabled={soutYnState === "Y"} onClick={()=>CntStateChngFunc("-")}>
                                    -
                                </button>
                                <div>
                                    <p>{countState}</p>
                                </div>
                                <button disabled={soutYnState === "Y"} onClick={()=>CntStateChngFunc("+")}>
                                    +
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div className="itemTxtRow">
                        <ul>
                            <li className="prdtLbl">
                                <p>{langData&&langData.GAME_SHOP_TOT_PRC_LBL_00}</p>
                                {/* 결제금액 */}
                            </li>
                            <li  className="lblValue red">
                                <p><span>{pchsCrncySignState}</span>{(Number(prdtUntPrcState||0)*countState).toLocaleString()}</p>
                            </li>
                        </ul>
                    </div>
                    {allTimeYnState ==="N"?
                    <div className="itemTxtRow">
                        <ul>
                            <li className="prdtLbl">
                                <p>{langData&&langData.GAME_SHOP_MNY_DPST_LBL_00}</p>
                                {/* 판매 기간 */}
                            </li>
                            <li className="lblValue">        
                                {aplyStopDtimeState ==="2999-12-31 23:59"?
                                 <p>{langData&&langData.GAME_SHOP_MNY_DPST_LBL_01}</p>
                                 :
                                 <p>{aplyStrtDtimeState} ~ {aplyStopDtimeState}</p>
                                }                        
                            </li>
                        </ul>
                    </div>:
                    <></>

                    }
                    <div className="itemTxtRow">
                        <ul>
                            <li className="prdtLbl">
                                <p>{langData&&langData.GAME_SHOP_MNY_PRDT_LBL_00}</p>
                            </li>
                            <li className="lblValue red"> 
                                {totMnyState > 0 ? 
                                    <p>{(Number(totMnyState||0)*countState).toLocaleString()} {prdtCtntRepsState?.gameMnyNm}</p>:
                                    <p>{prdtNmState}</p>
                                }                               
                            </li>
                        </ul>
                    </div>
                    <div className="itemTxBtnWrap">
                        <button
                            className={`buttonBgB ${soutYnState === "Y" || !isPageReady ? "disabled" : ""}`}
                            disabled={soutYnState === "Y" || !isPageReady}
                            onClick={()=>GameMnyPopFunc(`/GameMnyDpstPop?gameSvcCd=${getGameSvcCd}&prdtKindCd=${ShopKindCdState}&prdtCd=${getPrdtCd}&dpstPrdtCnt=${countState}&prdtUntPrc=${prdtUntPrcState}&pchsCrncySign=${pchsCrncySignState}&lang=${MgpStore.getState().LangSetState.Lang}`)}>
                            <p>{soutYnState === "Y" ? (langData&&langData.PRDT_SOLD_OUT_BTN_00) : (langData&&langData.GAME_SHOP_MNY_DPST_BTN_00)}</p>
                        </button>
                    </div>
                </div>
            </div>
            <div className="shopContainer">
                <h1 className="trmsCtgrTitl ctntCtgrTitlTxt">{langData&&langData.GAME_SHOP_PRDT_DESC_LBL_00}
                    <a href={"/GamePage/GamePrbb?gameSvcCd=BBO"} target="_blank">
                        <p>{langData&&langData.GLB_PRBB_LINK_BTN}</p>
                        <img src={process.env.PUBLIC_URL + "/images/blankIcon.png"} alt="" />
                    </a>
                </h1>
                {prdtDescState != null ? (
                    <div className="prdtDesc" style={{padding: "15px", whiteSpace: "pre-wrap"}}
                        dangerouslySetInnerHTML={{ __html: prdtDescState }}
                    />
                ) : null}
            </div>
        </div>
        </>
    )
}



export default ShopCtntUi;